import {SortOrder} from "../sort-order";

export class DefaultDecoderFilters {
  name: string;
  type: string;
  sortField: string;
  sortOrder: SortOrder;
}
